import React from 'react';
import { useNavigate, useSubmit, useActionData, useLoaderData, redirect } from 'react-router-dom';
import { ContentFrame } from '../../components/content_frame/content_frame';
import {getModel} from '../../utils/functions';
import { DESKTOP_PATH, STAFF_LIST_PATH, STAFF_ADD_PATH, STAFF_EDIT_PATH, LOGIN_PATH } from '../../constants/paths';
import { STAFF_GET_API } from '../../constants/apis';
import { StaffData } from './staff_data';


const DEFAULT_USER = {
  name: "",
  email: "",
  is_active: true
};

export async function staffAddLoader() {
  return DEFAULT_USER;
};

export async function staffEditLoader({ params }) {
  try {
    return await getModel(`${STAFF_GET_API}${params.user_id}`);
  }
  catch(errors) {
    if(errors instanceof Array) {
      for(let error of errors) {
        if(error.code === 209) {
          // Expired user session
          return redirect(LOGIN_PATH);
        }
        else if(error.code === 203) {
          // Not authorized
          return redirect(DESKTOP_PATH);
        }
      }
    }

    throw errors;    
  }
};


class Staff extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        password: "",
        password_confirmation: "",
        ...this.props.user
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.setState({
        user: {
          password: "",
          password_confirmation: "",
          ...this.props.user
        }
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const newData = {...this.state.user, [name]: value};

    this.setState({
      user: newData
    });
  }

  inputsAreValid() {    
    return this.state.user.name.length > 0 &&
           this.state.user.email.match(/.+@.+\..+/) != null &&
           (this.state.user.password.length <= 0 || (this.state.user.password.length > 0 && this.state.user.password_confirmation.length > 0));
  }

  clearWarningMessage() {
    this.props.submit(
      {resetWarnings: true}, 
      {
        method: 'POST',
        encType: "application/json"
      });
  }

  async saveData() {
    let data = {...this.state.user};
    
    this.props.submit(
      {data}, 
      {
        method: this.props.isEdit ? 'PATCH' : 'POST',
        encType: "application/json"
      });
  }

  async onCopyPasswordDefinitionLink() {
    this.props.submit(
      {copyPasswordLink: true}, 
      {
        method: 'POST',
        encType: "application/json"
      });
  }

  render() {
    return (
      <ContentFrame
        headerHistory={[
          {
            path: DESKTOP_PATH,
            text: "Área de trabalho"
          },
          {
            path: STAFF_LIST_PATH,
            text: "Listar colaboradores"
          },
          {
            path: this.props.isEdit ? STAFF_EDIT_PATH : STAFF_ADD_PATH,
            text: this.props.isEdit ? 'Editar colaborador' : 'Adicionar colaborador'
          },
        ]}
        titleIcon={this.props.isEdit ? <i className="fas fa-edit"></i> : <i className="fas fa-plus"></i>}
        title={this.props.isEdit ? 'Editar colaborador' : 'Adicionar colaborador'}
      >

        <StaffData
          warningMessage={this.props.warningMessage}
          showWarningMessage={this.props.warningMessage.length > 0}
          user={this.state.user}
          onSave={() => this.saveData()}
          onCloseWarning={() => this.clearWarningMessage()}
          enableSave={this.inputsAreValid()}
          handleInputChange={(event) => this.handleInputChange(event)}
          highlights={this.props.parametersToHighlight}
          onCancelPath={STAFF_LIST_PATH}
          onCopyPasswordDefinitionLink={() => this.onCopyPasswordDefinitionLink()}
          passwordRecoveryLinkCopied={this.props.passwordRecoveryLinkCopied}
          isEdit={this.props.isEdit}
        />

      </ContentFrame>
    );
  }
};

const WrappedStaff = props => {
  const user = useLoaderData();
  const navigate = useNavigate();
  const submit = useSubmit();
  const actionData = useActionData();

  let warningMessage = '';
  let parametersToHighlight = [];
  let passwordRecoveryLinkCopied = false;

  if (actionData) {
    warningMessage = actionData.message || '';
    parametersToHighlight = actionData.parameters || [];
    passwordRecoveryLinkCopied = actionData.passwordRecoveryLinkCopied || false;
  }  

  return (
    <Staff
      navigate={navigate}
      submit={submit}
      warningMessage={warningMessage}
      parametersToHighlight={parametersToHighlight}
      user={user}
      passwordRecoveryLinkCopied={passwordRecoveryLinkCopied}
      {...props}
    />
  );
};

export { WrappedStaff as Staff};
